import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var SET_IS_SEARCHABLE = 'classpass/searchmap/SET_IS_SEARCHABLE';
export var SET_POPUP = 'classpass/searchmap/SET_POPUP';
export var CLEAR_POPUP = 'classpass/searchmap/CLEAR_POPUP';
export var HIGHLIGHT_VENUE = 'classpass/searchmap/HIGHLIGHT_VENUE';
export var UNHIGHLIGHT_VENUE = 'classpass/searchmap/UNHIGHLIGHT_VENUE';
export var SET_VIEWPORT = 'classpass/searchmap/SET_VIEWPORT';
export var setPopup = function setPopup(popup) {
  return {
    type: SET_POPUP,
    key: 'popup',
    value: popup
  };
};
export var clearPopup = function clearPopup() {
  return {
    type: CLEAR_POPUP,
    key: 'popup',
    value: {}
  };
};
export var setIsSearchable = function setIsSearchable(isSearchable) {
  return {
    type: SET_IS_SEARCHABLE,
    key: 'isSearchable',
    value: isSearchable
  };
};
export var setViewport = function setViewport(viewport) {
  return {
    type: SET_VIEWPORT,
    key: 'viewport',
    value: viewport
  };
};
export var highlightVenue = function highlightVenue(venueId) {
  return {
    type: HIGHLIGHT_VENUE,
    venueId: venueId
  };
};
export var unhighlightVenue = function unhighlightVenue() {
  return {
    type: UNHIGHLIGHT_VENUE
  };
};
export var selectSearchMapState = function selectSearchMapState(state) {
  return state.features.searchMap;
};
export var selectPopup = function selectPopup(state) {
  return selectSearchMapState(state).popup;
};
export var selectIsSearchable = function selectIsSearchable(state) {
  return selectSearchMapState(state).isSearchable;
};
export var selectViewport = function selectViewport(state) {
  return selectSearchMapState(state).viewport;
};
export var selectHighlightedVenueId = function selectHighlightedVenueId(state) {
  return selectSearchMapState(state).highlightedVenueId;
};
var initialState = {
  popup: {},
  isSearchable: false,
  highlightedVenueId: null,
  viewport: {},
  hasRadiusBeenCalculated: false
};
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_IS_SEARCHABLE:
    case SET_POPUP:
    case CLEAR_POPUP:
    case SET_VIEWPORT:
      return _objectSpread({}, state, _defineProperty({}, action.key, action.value));

    case HIGHLIGHT_VENUE:
      return _objectSpread({}, state, {
        highlightedVenueId: action.venueId
      });

    case UNHIGHLIGHT_VENUE:
      return _objectSpread({}, state, {
        highlightedVenueId: null
      });

    default:
      return state;
  }
}